import { Form } from "react-bootstrap";
import './Text.css';

export default function Text({ label, placeholder, value, required, onChange, style, help, id, moreInfo, testId, disabled, onBlur, onKeyDown }) {
    return (
        <>
            {label && <Form.Label htmlFor={id} title={help ?? ""} style={help ? { cursor: 'help', fontWeight: 500 } : { fontWeight: 500 }}>{label}</Form.Label>}
            {moreInfo && <p className="more-info">{moreInfo}</p>}
            <Form.Control
                // className="text-input"
                id={id}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                style={style}
                type="text"
                required={required}
                data-testid={testId}
                disabled={disabled}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
            />
        </>
    )
}
